import(/* webpackMode: "eager", webpackExports: ["Analytics","QProvider"] */ "/vercel/path0/app/Client.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SocialLink","Search"] */ "/vercel/path0/componentry/Navigation/Elements.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/vercel/path0/componentry/Navigation/Mobile.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/componentry/Navigation/Sidebar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar"] */ "/vercel/path0/componentry/Providers.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/legacy_componentry/AppDir/Navigation.client.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/new-swiper/modules/scrollbar-element.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/new-swiper/modules/navigation-element.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
